import * as React from 'react';
import { memo } from 'react';

import { Group as GroupType, Option } from '../../../Autocomplete/types';
import { Location } from '../../types';
import { useTheme } from '../../../theme';

interface Props {
	group: GroupType<Location>;
	optionRenderer: (option: Option<Location>, key: number) => React.ReactNode;
}

const Group = memo<Props>(({ group, optionRenderer }) => {
	const { Group: css } = useTheme('LocationAutocomplete');

	return (
		<div className={css.group}>
			{group.label && <label className={css.group__label}>{group.label}</label>}

			{group.options.map(optionRenderer)}
		</div>
	);
});

export default Group;
